/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S3_BodyInputs */

const tr_kullanim_s3_body = /** @type {(inputs: Kullanim_S3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şirket'in, Platform aracılığıyla sunduğu Hizmetler'den Kullanıcı'nın yararlanmasının koşulları, tarafların hak ve yükümlülükleri, ücret ve ödeme koşulları, fikri haklar ve sorumluluk sınırlarının belirlenmesi bu Sözleşme'nin konusunu oluşturur.`)
};

const en_kullanim_s3_body = /** @type {(inputs: Kullanim_S3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The subject matter of this Agreement is the determination of the conditions under which the User benefits from the Services offered by the Company through the Platform, of the rights and obligations of the parties, of the fee and payment terms, of the intellectual property rights and of the limits of liability.`)
};

const de_kullanim_s3_body = /** @type {(inputs: Kullanim_S3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gegenstand dieses Vertrags ist die Festlegung der Bedingungen, unter denen der Nutzer die vom Unternehmen über die Plattform angebotenen Dienste in Anspruch nimmt, der Rechte und Pflichten der Parteien, der Entgelt- und Zahlungsbedingungen, der geistigen Eigentumsrechte und der Haftungsgrenzen.`)
};

const ru_kullanim_s3_body = /** @type {(inputs: Kullanim_S3_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предметом настоящего Договора является определение условий пользования Пользователем Услугами, предоставляемыми Компанией через Платформу, прав и обязанностей сторон, условий оплаты и платежей, прав интеллектуальной собственности и пределов ответственности.`)
};

/**
* | output |
* | --- |
* | "The subject matter of this Agreement is the determination of the conditions under which the User benefits from the Services offered by the Company through th..." |
*
* @param {Kullanim_S3_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s3_body = /** @type {((inputs?: Kullanim_S3_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S3_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s3_body(inputs)
	if (locale === "de") return de_kullanim_s3_body(inputs)
	if (locale === "ru") return ru_kullanim_s3_body(inputs)
	return tr_kullanim_s3_body(inputs)
});